export default defineNuxtRouteMiddleware(_to => {
  if (!process.client) return

  const isNative = useIsNative()
  const config = useRuntimeConfig().public

  if (!isNative) {
    const currentHost = window.location.host

    if (currentHost?.endsWith('torticity.com')) {
      const lawFirmName = currentHost.split('.')[0]
      const environment = config.appEnv === 'staging' ? '.staging' : ''

      const searchParams = new URLSearchParams(window.location.search)
      searchParams.set('brand', lawFirmName)

      const searchString = searchParams.toString()

      window.location.replace(`https://app${environment}.casewiseapp.com?${searchString}`)
    }
  }
})
